import type { StatusEntries } from "enums/partSerialStatus"
import * as partSerialStatus from "enums/partSerialStatus"
import { PlantDTOInner } from "models"

export interface StatusCell {
	count: int;
	percentage: int;
	statusName: string;
}

export type PlantsTableObj = {
	name: string
	id: string
	[statusId: string]: StatusCell | string
}

export class Plant extends PlantDTOInner {
	get DUNName(): string {
		return this.name + " - " + this.duns
	}

	ToTableObj(statusEntries?: StatusEntries): PlantsTableObj {
		const out = {} as PlantsTableObj
		out.name = this.name
		out.id = this.id

		const entries = statusEntries ?? (partSerialStatus.Statuses.Entries() as StatusEntries);
		for (const [statusName, statusDef] of entries) {
			const rawStatus = this.partSerialStatuses?.find(
				(s) => s.id === statusDef.id
			);
			out[statusDef.id] = {
				count: rawStatus?.count ?? 0,
				percentage: rawStatus?.percentage ?? 0,
				statusName,
			}
		}
		return out
	}
}
